import vert from './glsl/fade.vert.glsl';
import frag from './glsl/fade.frag.glsl';

export default { frag, vert };